import React, { FC } from 'react'
import { GridColDef } from '@mui/x-data-grid-premium'
import { GatewayColumnsDataGrid } from 'src/components/columns/gateway'
import { Gateway, GatewayState } from 'src/api'
import { CommonGatewayList } from './commonGatewaysList'

const columns: GridColDef<Gateway>[] = [
  GatewayColumnsDataGrid.DeviceId,
  GatewayColumnsDataGrid.IMEI,
  GatewayColumnsDataGrid.DevEUI,
  GatewayColumnsDataGrid.ExternalDeviceId,
  GatewayColumnsDataGrid.OnlineStatus,
  GatewayColumnsDataGrid.LastPingAt,
  GatewayColumnsDataGrid.Name,
  GatewayColumnsDataGrid.State,
  GatewayColumnsDataGrid.Contractor,
  GatewayColumnsDataGrid.Project,
  GatewayColumnsDataGrid.CreatedAt
]

interface InUseGatewayListProps {
  isLoading: boolean
  count: number
  data: Gateway[]
  states: GatewayState[]
  refetchGatewayList: () => void
}

export const InUseGatewayList: FC<InUseGatewayListProps> = ({ data, isLoading, count }) => {
  return <CommonGatewayList columns={columns} count={count} data={data} isLoading={isLoading} />
}
